import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DataService } from '../data.service';
import { PINChangeRequest } from '../models/PINChangeRequest';

@Component({
  selector: 'app-pinchange',
  templateUrl: './pinchange.component.html',
  styleUrls: ['./pinchange.component.scss']
})
export class PinchangeComponent implements OnInit {

  constructor(private router:Router,private data:DataService) { }
  public req : PINChangeRequest = new PINChangeRequest();
  public confirmPin: string;
  public errMessage:string = "";

  ngOnInit(): void {
  }

  onPinChangeSubmit() : void {
    if (!this.validate()){
      return;
    }
    this.data.request<string>("kiosk/pinchange",this.req,"POST").subscribe((e)=>{
      this.data.SelectedProperty = null;
      this.data.token = "";
      this.data.SelectedCardBearer = null;
      this.data.SelectedCardBearerID = "";
      this.data.SelectedOwner = null;
      this.data.showBackButton = false;
      this.router.navigate(["login"],{skipLocationChange: true});
    },(error)=>{
      this.errMessage = "Failed to change the PIN, please try again";
    })
  }

  validate(): boolean {
    if (!new RegExp('^[0-9]{6}$').test(this.req.currentpin)){
      this.errMessage = "6 digit current pin is required";
      return false;
    } else if (!new RegExp('^[0-9]{6}$').test(this.req.newpin)){
      this.errMessage = "6 digit new pin is required";
      return false;
    }else if (this.req.newpin != this.confirmPin){
      this.errMessage = "New PIN and confirmation does not match";
      return false;
    }else {
      return true;
    }
  }

}
